// initial state
const state = () => ({
  guestProfileId: false,
  isKeyboardOpen: false,
  currentComponent: null,
  isLoggedIn: false,
  registrationForm: {
    name: null,
    email: null,
    password: null,
    gender: null,
    age: null,
    preferred_gender: null,
    location_id: null,
    birth_date: null,
    is_verification_required: false,
    email_verified_at: null,
    filled_at: null,
  },
});

// getters
const getters = {
  getCurrentComponent: (state) => {
    return state.currentComponent;
  },
  getRegistrationForm: (state) => {
    return state.registrationForm;
  },
  getIsLoggedIn: (state) => {
    return state.isLoggedIn;
  },
  getIsKeyboardOpen: (state) => {
    return state.isKeyboardOpen;
  },
  getGuestProfileId: (state) => {
    return state.guestProfileId;
  },
};

// actions
const actions = {
  updateRegistrationForm({ commit }, userData) {
    commit('setName', userData.name);
    commit('setEmail', userData.email);
    commit('setGender', userData.gender);
    commit('setBirthDate', userData.birth_date);
    commit('setPreferredGender', userData.preferred_gender);
    commit('setLocationId', userData.location_id);
    commit('setEmailVerifiedAt', userData.email_verified_at);
    commit('setIsVerificationRequired', userData.is_verification_required);
    commit('setFilledAt', userData.filled_at);
  },
  async submitUpdateRegistration({ state }) {
    let form = { ...state.registrationForm };

    form.preferred_gender = [form.preferred_gender ?? 'female'];
    form.birth_date = form.birth_date.toISOString().split('T')[0];
    form.cid = window.localStorage.getItem('campaign_cid');
    form.eid = window.localStorage.getItem('campaign_eid');
    form.campaign_query = window.localStorage.getItem('campaign_query');
    const { profileId, userEmail } = JSON.parse(localStorage.getItem('guest_data') || '{}');

    axios
      .put(zRoute('register.update'), form)
      .then((response) => {
        if (response.data.status === 'success') {
          if (profileId && userEmail === form.email) {
            window.localStorage.removeItem('guest_data');
            window.location = `/profile/${profileId}`;
          } else {
            window.location.reload();
          }
        }
      })
      .catch(() => {});
  },
};

// mutations
const mutations = {
  setCurrentComponent: (state, currentComponent) => {
    state.currentComponent = currentComponent;
  },
  setName: (state, name) => {
    state.registrationForm.name = name;
  },
  setEmail: (state, email) => {
    state.registrationForm.email = email;
  },
  setPassword: (state, password) => {
    state.registrationForm.password = password;
  },
  setGender: (state, gender) => {
    state.registrationForm.gender = gender;
  },
  setPreferredGender: (state, preferred_gender) => {
    if (Array.isArray(preferred_gender)) {
      if (preferred_gender.length > 0) {
        state.registrationForm.preferred_gender = preferred_gender[0];
      } else {
        state.registrationForm.preferred_gender = null;
      }
    } else {
      state.registrationForm.preferred_gender = preferred_gender;
    }
  },
  setLocationId: (state, location_id) => {
    state.registrationForm.location_id = location_id;
  },
  setAge: (state, age) => {
    state.registrationForm.age = age;

    if (age) {
      const today = new Date();
      const currentYear = today.getFullYear();
      const birthYear = currentYear - age;
      let birthDate = new Date(birthYear, today.getMonth(), today.getDate());
      birthDate.setHours(12);
      state.registrationForm.birth_date = birthDate;
    } else {
      state.registrationForm.birth_date = null;
    }
  },
  setBirthDate: (state, birth_date) => {
    if (!birth_date) {
      state.registrationForm.age = null;
    } else {
      const [day, month, year] = birth_date.split(' ').map(Number);
      state.registrationForm.birth_date = new Date(year, month - 1, day);
      state.registrationForm.age = Math.floor((new Date() - state.registrationForm.birth_date.getTime()) / 3.15576e+10);
    }
  },
  setIsLoggedIn: (state, isLoggedIn) => {
    state.isLoggedIn = isLoggedIn;
  },
  setEmailVerifiedAt: (state, emailVerifiedAt) => {
    state.registrationForm.email_verified_at = emailVerifiedAt;
  },
  setIsVerificationRequired: (state, isVerificationRequired) => {
    state.registrationForm.is_verification_required = isVerificationRequired;
  },
  setIsKeyboardOpen: (state, isKeyboardOpen) => {
    state.isKeyboardOpen = isKeyboardOpen;
  },
  setFilledAt: (state, filledAt) => {
    state.registrationForm.filled_at = filledAt;
  },
  setGuestProfileId: (state, guestProfileId) => {
    state.guestProfileId = guestProfileId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
